<template>
    <div class="picDetail">
        <div class="picBox" id="container">
            <div v-viewer class="images clearfix">
                <template v-for="image in picDetailList">
                    <img v-lazy.container="url+image">
                    <!-- <img :src="url+image" class="image" :key="image" v-lazy.container="image"> -->
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import 'viewerjs/dist/viewer.css'
    import { Lazyload } from 'mint-ui';
    import Viewer from 'v-viewer'
    Vue.use(Lazyload, {
        error: './static/error.png',
        loading: './static/loading.png'
    });
    Vue.use(Viewer, {
        defaultOptions: {
            zIndex: 9999
        }
    })

    import { getActivityImgsById } from '../../api/api.js'
    export default {
        name: 'picDetail',
        created() {
            let id = this.$route.query.id;
            getActivityImgsById({ id: id }).then(res => {
                this.picDetailList = res.data.data.companyNewsImg.split(',')
            });
        },
        data() {
            return {
                url: this.GLOBAL.picURL,
                picDetailList: []
            }
        }
    }
</script>

<style lang='scss' scoped>
    .picBox {
        .images {
            img {
                width: 100%;
            }
        }

    }

    image[lazy=loading] {
        width: 100%;
        // width: 40px;
        // height: 300px;
        // margin: auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/mobile/MpicDetail.vue